"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var d3_1 = require("d3");
var moment_1 = tslib_1.__importDefault(require("moment"));
var shape_1 = require("./shape");
var svg_helper_1 = require("../lib/svg-helper");
var get_category_index_1 = require("../lib/get-category-index");
var Bar = /** @class */ (function (_super) {
    tslib_1.__extends(Bar, _super);
    function Bar(ctx, coord, helpers, maxBarWidth) {
        var _this = _super.call(this, ctx, coord, helpers) || this;
        /**
         * 分类轴数据比例尺类型
         * @since 2.0
         */
        _this.categoryScaleType = "Band";
        /**
         * 高亮的元素
         * @since 2.3
         */
        _this.highlightElements = [];
        _this.maxBarWidth = maxBarWidth;
        _this.crosshair = _this.ctx.root
            .append("path")
            .attr("class", _this.ctx.classPrefix + "-chart-crosshair")
            .attr("data-z-index", "2")
            .attr("stroke", "#000")
            .attr("stroke-width", 1)
            .attr("opacity", 0.05)
            .attr("style", "pointer-events:none;")
            .attr("visibility", "hidden");
        _this.ctx.on("plot.mouse.move", _this.onMouseMove, _this);
        _this.ctx.on("plot.mouse.left", _this.removeHover, _this);
        _this.ctx.on("plot.mouse.click", _this.onClick, _this);
        _this.ctx.on("legend.hover", _this.onLegendItemHover, _this);
        _this.ctx.on("legend.left", _this.onLegendItemLeft, _this);
        _this.ctx.on("legend.clicked", _this.onLegendClick, _this);
        _this.ctx.on("coord.zoom.zooming", _this.onZoom, _this);
        _this.ctx.on("coord.zoom.reset", _this.onZoomReset, _this);
        return _this;
    }
    /**
     * @implements Shape
     * @param pos 数据映射关系
     * @since 2.0
     */
    Bar.prototype.position = function (pos) {
        this.model.source(this.ctx.dataSource);
        var _a = tslib_1.__read(this.ctx.dataSource, 1), _b = _a[0], first = _b === void 0 ? {} : _b;
        if (typeof pos === "string") {
            var _c = tslib_1.__read(pos.split("*"), 2), x = _c[0], y = _c[1];
            if (typeof first[y] === "number" || first[y] === null) {
                this.categoryKey = x;
                this.valueKey = y;
                this.invert = false;
            }
            else {
                this.categoryKey = y;
                this.valueKey = x;
                this.invert = true;
            }
        }
        return this;
    };
    /**
     * @implements
     * @param {string} color 作为数据系列映射字段
     * @param {Color} color 以 Color 的配置来设置颜色与数据系列映射关系
     * @since 2.0
     */
    Bar.prototype.color = function (color) {
        var key;
        if (typeof color === "string") {
            key = color;
        }
        else if (Array.isArray(color)) {
            this.ctx.theme.color = color;
        }
        else if (typeof color === "object" && color !== null) {
            var formatter = color.formatter, colors = color.colors;
            (key = color.key);
            if (colors) {
                this.ctx.theme.color = colors;
            }
            else {
                this.ctx.theme.color = null;
            }
            if (formatter) {
                this.colorAttrCallback = formatter;
            }
        }
        else {
            this.colorKey = null;
            this.serieKey = null;
        }
        if (key !== this.categoryKey) {
            this.serieKey = key;
        }
        this.colorKey = key;
        return this;
    };
    Bar.prototype.size = function (size) {
        this.shapeSize = size;
        return this;
    };
    /**
     * 每个 X 轴点对应柱形的最大宽度
     * @param {number} maxBarWidth 最大宽度
     * @since 2.0
     */
    Bar.prototype.maxWidth = function (maxBarWidth) {
        this.maxBarWidth = maxBarWidth;
        return this;
    };
    /**
     * 设置坐标轴配置
     * @param axis 坐标轴配置
     * @since 2.0
     */
    Bar.prototype.axis = function (axis) {
        if (axis.xAxis) {
            this.ctx.setOption("axis.xAxis", axis.xAxis);
        }
        if (axis.yAxis) {
            this.ctx.setOption("axis.yAxis", axis.yAxis);
        }
        return this;
    };
    /**
     * @implements
     * @since 2.0
     */
    Bar.prototype.updateModel = function () {
        var xSort = null;
        var _a = this.ctx.getOption("scale." + this.categoryKey, {
            type: "category",
            timeParseFormat: false,
        }), type = _a.type, timeParseFormat = _a.timeParseFormat;
        if (type === "time") {
            xSort = function (a, b) {
                return d3_1.ascending(moment_1.default(a, timeParseFormat).valueOf(), moment_1.default(b, timeParseFormat).valueOf());
            };
        }
        var stack = this.ctx.getOption("scale." + this.valueKey, {
            stack: false,
        }).stack;
        this.model.define(this.categoryKey, this.valueKey, this.serieKey, this.colorKey, xSort, !!stack, stack === "percent" ? stack : "stack");
    };
    /**
     * 更新颜色比例尺
     * @implements
     * @since 2.0
     */
    Bar.prototype.updateColorScale = function () {
        var colorDomain = this.model.getKeyNames(this.colorKey);
        var _a = this.ctx.theme, color = _a.color, defaultColor = _a.defaultColor;
        var colorRange = [];
        if (typeof color === "function") {
            for (var i = 0; i < colorDomain.length; i++) {
                colorRange.push(color(colorDomain[i], i, i === colorDomain.length - 1));
            }
        }
        else if (Array.isArray(color)) {
            colorRange = color;
        }
        else {
            colorRange = defaultColor;
        }
        this.colorScale = d3_1.scaleOrdinal()
            .domain(colorDomain)
            .range(colorRange);
    };
    /**
     * 更新数据比例尺
     * @implements
     * @since 2.0
     */
    Bar.prototype.updateDataScale = function () {
        var seriesDomain = this.model.getSerieNames();
        var categoryDomain = this.model.getCategoryNames();
        this.categoryScale = [
            d3_1.scaleBand()
                .domain(categoryDomain)
                .paddingInner(0.1)
                .align(0.5),
            d3_1.scaleBand()
                .domain(seriesDomain)
                .paddingInner(0.05)
                .align(0.5),
        ];
        var _a = this.ctx.getOption("scale." + this.valueKey, {
            domain: null,
        }), domain = _a.domain, stack = _a.stack;
        if (stack && stack === "percent") {
            this.valueScale = d3_1.scaleLinear().domain([0, 100]);
        }
        else {
            var autofit = domain === "autofit";
            var valueDomain = Array.isArray(domain)
                ? domain
                : this.model.getExtent(autofit);
            this.valueScale = d3_1.scaleLinear()
                .domain(valueDomain)
                .nice(10);
        }
    };
    /**
     * 开始绘图
     * @implements
     * @since 2.0
     */
    Bar.prototype.draw = function (updateModel) {
        if (updateModel === void 0) { updateModel = true; }
        if (updateModel)
            this.updateModel();
        this.updateColorScale();
        this.updateDataScale();
        // 先更新图例的位置
        this.helpers.legend.update(this.colorScale, this.valueKey, "line", this.model);
        // 更新坐标轴
        this.coordinate.draw(this.valueScale, this.categoryScale, this.categoryScaleType, this.invert);
        this.drawSeries();
        var _a = this.ctx.getOption("interaction"), brush = _a.brush, zoom = _a.zoom;
        this.helpers.selection.setEnable(!!brush || !!zoom);
    };
    /**
     * 绘制柱状图
     * @since 2.0
     */
    Bar.prototype.drawSeries = function () {
        var e_1, _a, e_2, _b;
        var _this = this;
        var ctx = this.ctx;
        var _c = this.ctx, classPrefix = _c.classPrefix, id = _c.id;
        var series = this.model.getSerieNames();
        var categories = this.model.getCategoryNames();
        var _d = tslib_1.__read(this.categoryScale, 2), categoryScale = _d[0], serieScale = _d[1];
        var serieCls = classPrefix + "-chart-series " + classPrefix + "-chart-bar-series";
        var markersCls = classPrefix + "-chart-markers " + classPrefix + "-chart-bar-series";
        var shape = this;
        this.seriesGroup.selectAll("g").remove();
        var useMaxWidth = false;
        if (this.shapeSize) {
            serieScale.range([0, this.shapeSize * series.length]);
        }
        else if ((!this.model.stack && serieScale.bandwidth() > this.maxBarWidth) ||
            (this.model.stack && categoryScale.bandwidth() > this.maxBarWidth)) {
            serieScale.range([0, this.maxBarWidth * series.length]);
            useMaxWidth = true;
        }
        var domain = this.valueScale.domain(); // 值轴值域
        var min = domain[0];
        var max = domain[1];
        var zeroPos = this.valueScale(min < 0 ? 0 : min); // 值轴 0 值位置
        var datum = {};
        var isStack = !!this.model.stack; // 是否为堆叠图
        var isPercentStack = this.model.stack && this.model.stackType === "percent";
        try {
            for (var categories_1 = tslib_1.__values(categories), categories_1_1 = categories_1.next(); !categories_1_1.done; categories_1_1 = categories_1.next()) {
                var category = categories_1_1.value;
                var dataPoints = this.model.getDataFromCategoryName(category, true);
                try {
                    for (var dataPoints_1 = (e_2 = void 0, tslib_1.__values(dataPoints)), dataPoints_1_1 = dataPoints_1.next(); !dataPoints_1_1.done; dataPoints_1_1 = dataPoints_1.next()) {
                        var point = dataPoints_1_1.value;
                        var stackPercent = point.stackPercent, value = point.value, stackValue = point.stackValue, percent = point.percent, category_1 = point.category, serieName = point.serieName, colorName = point.colorName;
                        var color = this.colorScale(colorName);
                        var rawValue = isPercentStack ? percent : value;
                        var isNegative = rawValue < 0;
                        // 计算值轴位置
                        var posValue = value; // 映射在值轴的值
                        if (isStack) {
                            posValue = posValue < 0 ? stackValue - value : stackValue;
                        }
                        else {
                            posValue = posValue < 0 ? 0 : value;
                        }
                        if (posValue > max)
                            posValue = max;
                        if (posValue < min)
                            posValue = min;
                        var valueMapPos = this.valueScale(isPercentStack ? stackPercent : posValue); // 矩形顶部映射在图形的 y 值（如果是横向坐标轴则是右侧 X 轴的值）
                        var metric = 0; // 映射为高度或者宽度
                        if (rawValue !== null) {
                            if (isStack) {
                                if (isNegative) {
                                    metric = Math.abs(this.valueScale(rawValue) - zeroPos);
                                }
                                else {
                                    // 如果是堆叠图
                                    metric = Math.abs(zeroPos - this.valueScale(rawValue));
                                }
                            }
                            else {
                                // 如果为非堆叠图，则基本高度为 Y 坐标 - Y 轴 0 值坐标
                                metric = Math.abs(this.valueScale(rawValue) - zeroPos);
                            }
                        }
                        // 计算分类轴坐标
                        var catPos = categoryScale(category_1) || 0;
                        if (this.shapeSize) {
                            catPos += categoryScale.bandwidth() / 2 - this.shapeSize / 2;
                        }
                        else if (!isStack && useMaxWidth) {
                            catPos +=
                                categoryScale.bandwidth() / 2 -
                                    (this.maxBarWidth * series.length) / 2;
                        }
                        else if (isStack && useMaxWidth) {
                            catPos += categoryScale.bandwidth() / 2 - this.maxBarWidth / 2;
                        }
                        if (!isStack)
                            catPos += serieScale(serieName);
                        if (!datum[serieName])
                            datum[serieName] = [];
                        datum[serieName].push({
                            x: this.invert ? valueMapPos - metric : catPos,
                            y: this.invert ? catPos : valueMapPos,
                            category: category_1,
                            value: value,
                            color: color,
                            metric: metric,
                            originValue: value,
                            dataLeaf: point,
                        });
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (dataPoints_1_1 && !dataPoints_1_1.done && (_b = dataPoints_1.return)) _b.call(dataPoints_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (categories_1_1 && !categories_1_1.done && (_a = categories_1.return)) _a.call(categories_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // eslint-disable-next-line no-nested-ternary
        var barWidth = useMaxWidth
            ? this.maxBarWidth
            : isStack
                ? categoryScale.bandwidth()
                : serieScale.bandwidth();
        var rectWidth = shape.shapeSize || barWidth;
        var selectEnable = this.ctx.getOption("interaction.element-select");
        var bar = this;
        this.seriesGroup
            .selectAll("." + serieCls)
            .data(series)
            .join("g")
            .attr("class", function (_, i) { return serieCls + " " + classPrefix + "-chart-series-" + i; })
            .attr("clip-path", "url(#" + id + ")")
            .call(function (g) {
            var _a = _this, invert = _a.invert, colorAttrCallback = _a.colorAttrCallback;
            g.each(function serie(serieName) {
                var serieGroup = d3_1.select(this);
                var data = datum[serieName];
                // 绘制柱形图
                serieGroup
                    .selectAll("rect")
                    .data(data)
                    .join("rect")
                    .attr("style", function (d) {
                    var cursor = selectEnable ? "pointer" : "normal";
                    var _a = (d || {}).color, color = _a === void 0 ? "none" : _a;
                    if (colorAttrCallback) {
                        color = colorAttrCallback(d.dataLeaf) || d.color;
                    }
                    return "fill:" + color + ";cursor:" + cursor + ";";
                })
                    .attr("class", classPrefix + "-chart-point")
                    .attr("width", function (_a) {
                    var metric = _a.metric;
                    if (invert)
                        return metric;
                    return rectWidth;
                })
                    .attr("x", function (_a) {
                    var x = _a.x;
                    return x;
                })
                    .attr("y", function (_a) {
                    var y = _a.y;
                    return y;
                })
                    .attr("height", function (_a) {
                    var metric = _a.metric;
                    if (invert)
                        return rectWidth;
                    return metric;
                })
                    .call(function (g) {
                    bar.highlightElements = [];
                    g.each(function rect(data) {
                        var rectElement = d3_1.select(this);
                        var _a = (ctx.theme || {}).interaction, interaction = _a === void 0 ? { selected: {} } : _a;
                        var selected = interaction.selected;
                        // 处理 element-select 交互事件
                        rectElement.on("click", function () {
                            if (selectEnable) {
                                bar.highlightElements.forEach(function (r) {
                                    var _a = tslib_1.__read(r.data(), 1), data = _a[0];
                                    if (data.color) {
                                        r.style("fill", data.color);
                                    }
                                    r.style("opacity", 1);
                                });
                                var mappedData = bar.getData(data.x, data.y);
                                ctx.emit("interaction.selected", mappedData, data);
                                if (selected.fill) {
                                    rectElement.style("fill", selected.fill);
                                }
                                if (selected.opacity) {
                                    rectElement.style("opacity", selected.opacity);
                                }
                                // 目前只支持单个元素点击
                                bar.highlightElements = [rectElement];
                            }
                        });
                    });
                });
            });
        });
        this.seriesGroup
            .selectAll("." + markersCls)
            .data(series)
            .join("g")
            .attr("class", function (_, i) { return markersCls + " " + classPrefix + "-chart-series-" + i; });
        var maxSerieIndex = series.length;
        for (var start = 0; start <= maxSerieIndex; start++) {
            this.seriesGroup
                .selectAll("." + classPrefix + "-chart-series-" + start)
                .raise();
        }
        /**
         * @todo 从 drawSeries 移除出去
         */
        var dataLabelEnable = this.options.dataLabels.enable;
        var stackLabelEnable = this.ctx.getOption("scale." + this.valueKey + ".stackLabels.enable");
        this.ctx.root.selectAll("." + classPrefix + "-chart-data-labels").remove();
        this.ctx.root.selectAll("." + classPrefix + "-chart-stack-labels").remove();
        if (stackLabelEnable) {
            this.drawStackLabels(datum, rectWidth);
        }
        if (dataLabelEnable) {
            this.drawDataLabels(datum, rectWidth);
        }
    };
    /**
     *
     * 绘制堆叠数据值文本
     * @param datum 数据
     * @param barWidth 柱子的宽度
     */
    Bar.prototype.drawStackLabels = function (datum, barWidth) {
        var _a = this.ctx, root = _a.root, classPrefix = _a.classPrefix;
        var series = this.model.getSerieNames();
        var labelGroup = root
            .append("g")
            .attr("class", classPrefix + "-chart-stack-labels")
            .attr("data-z-index", 6);
        var labels = labelGroup
            .selectAll("g")
            .data(this.categoryScale[0].domain())
            .join("g")
            .attr("class", classPrefix + "-chart-label " + classPrefix + "-chart-stack-label");
        var text = labels
            .append("text")
            .attr("y", 11)
            .attr("text-anchor", "start")
            .attr("class", "font-size:11px;font-weight:bold;color:gray;fill:gray;")
            .attr("data-z-index", 1);
        text.append("tspan").text(function (category) {
            var e_3, _a;
            var categoriesDatum = [];
            try {
                for (var series_1 = tslib_1.__values(series), series_1_1 = series_1.next(); !series_1_1.done; series_1_1 = series_1.next()) {
                    var serie = series_1_1.value;
                    var data = datum[serie].find(function (d) { return d.category === category; });
                    if (data) {
                        categoriesDatum.push(data);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (series_1_1 && !series_1_1.done && (_a = series_1.return)) _a.call(series_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return d3_1.format(",")(d3_1.sum(categoriesDatum.map(function (d) { return d.originValue; })));
        });
        var invert = this.invert;
        labels.attr("transform", function transform(category) {
            var e_4, _a, _b, _c, _d;
            var categoriesDatum = [];
            try {
                for (var series_2 = tslib_1.__values(series), series_2_1 = series_2.next(); !series_2_1.done; series_2_1 = series_2.next()) {
                    var serie = series_2_1.value;
                    var data = datum[serie].find(function (d) { return d.category === category; });
                    if (data) {
                        categoriesDatum.push(data);
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (series_2_1 && !series_2_1.done && (_a = series_2.return)) _a.call(series_2);
                }
                finally { if (e_4) throw e_4.error; }
            }
            var x;
            var y;
            if (invert) {
                _b = tslib_1.__read(d3_1.extent(categoriesDatum.map(function (d) { return d.x + d.metric; })), 2), x = _b[1];
                _c = tslib_1.__read(categoriesDatum, 1), y = _c[0].y;
                var height = svg_helper_1.getLabelMaxHeight(d3_1.select(this).nodes());
                y = y + barWidth / 2 - height / 2;
            }
            else {
                var _e = tslib_1.__read(d3_1.extent(categoriesDatum.map(function (d) { return d.y; })), 1), minY = _e[0];
                _d = tslib_1.__read(categoriesDatum, 1), x = _d[0].x;
                var width = svg_helper_1.getLabelMaxWidth(d3_1.select(this).nodes());
                x = x + barWidth / 2 - width / 2;
                y = minY - 15;
            }
            return "translate(" + x + "," + y + ")";
        });
    };
    /**
     * 绘制数据值文本
     * @param datum 数据
     * @param barWidth 柱子的宽度
     */
    Bar.prototype.drawDataLabels = function (datum, barWidth) {
        var _a = this.ctx, root = _a.root, classPrefix = _a.classPrefix;
        var series = this.model.getSerieNames();
        var labelFormatter = this.options.dataLabels.formatter;
        var lablesGroup = root
            .selectAll("." + classPrefix + "-chart-data-labels")
            .data(series)
            .join("g")
            .attr("class", function (_, i) {
            return classPrefix + "-chart-data-labels " + classPrefix + "-chart-series-" + i;
        })
            .attr("data-z-index", 6);
        var labels = lablesGroup
            .selectAll("." + classPrefix + "-chart-label " + classPrefix + "-data-label")
            .data(function (d) { return datum[d]; })
            .join("g")
            .attr("class", classPrefix + "-chart-label " + classPrefix + "-data-label")
            .attr("data-z-index", 1);
        labels
            .append("text")
            .attr("data-z-index", 1)
            .attr("x", 0)
            .attr("y", this.invert ? 5 : 16)
            .attr("text-anchor", "middle")
            .attr("style", function () {
            return "font-size:11px;font-weight:bold;color:#000;fill:#000;";
        })
            .text(function (_a, i) {
            var originValue = _a.originValue, dataLeaf = _a.dataLeaf;
            if (typeof labelFormatter === "function") {
                return labelFormatter(originValue, i, dataLeaf);
            }
            return d3_1.format(",")(originValue);
        })
            .call(svg_helper_1.textWrap, this.invert, barWidth);
        var invert = this.invert;
        labels.attr("transform", function transform(_a) {
            var x = _a.x, y = _a.y, metric = _a.metric;
            var maxTextWidth = svg_helper_1.getLabelMaxWidth(d3_1.select(this).nodes());
            var maxTextHeight = svg_helper_1.getLabelMaxHeight(d3_1.select(this).nodes());
            if (invert) {
                return "translate(" + (x + metric / 2 - maxTextWidth / 2) + ", " + (y +
                    barWidth / 2 -
                    maxTextHeight / 2 +
                    4) + ")";
            }
            return "translate(" + (x +
                barWidth / 2) + ", " + (y + metric / 2 - maxTextHeight / 2 - 4) + ")";
        });
    };
    Bar.prototype.onMouseMove = function (x, y) {
        var tooltipEnable = this.ctx.getOption("tooltip.enable");
        if (tooltipEnable === false)
            return;
        var data = this.getData(x, y);
        if (data) {
            var allData = this.model.getAllData();
            this.drawHover(data);
            this.helpers.tooltip.show(data, allData);
            if (this.ctx.getOption("interaction.element-hover")) {
                if (this.currentHoverIndex !== data.index) {
                    this.ctx.emit("interaction.hover", data.metaData);
                    this.currentHoverIndex = data.index;
                }
            }
        }
        else {
            this.removeHover();
        }
    };
    /**
     * 根据坐标获取数据
     * @since 2.0
     * @param x x 坐标
     * @param y y 坐标
     */
    Bar.prototype.getData = function (x, y) {
        var e_5, _a;
        var cat = this.invert ? y : x;
        var _b = tslib_1.__read(this.categoryScale, 1), axisScale = _b[0];
        var domain = axisScale.domain();
        var index = get_category_index_1.getCategoryIndex(cat, axisScale, "Band");
        var dValue = domain[index];
        var pos = axisScale(dValue) + axisScale.bandwidth() / 2;
        if (index < 0 || Number.isNaN(index) || dValue === undefined)
            return null;
        if (index > domain.length - 1) {
            index = domain.length - 1;
        }
        var alias = this.ctx.getOption("scale." + this.valueKey + ".alias");
        var metaData = [];
        try {
            for (var _c = tslib_1.__values(this.model.getDataFromCategoryName(dValue, true)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = _d.value, serieName = _e.serieName, colorName = _e.colorName, value = _e.value, origin_1 = _e.origin, percent = _e.percent;
                metaData.push({
                    title: dValue,
                    label: alias || (serieName === "default" ? this.valueKey : serieName),
                    serieName: serieName,
                    valueText: typeof value === "number" ? d3_1.format(",")(value) : "-",
                    color: this.colorScale(colorName),
                    value: value,
                    row: origin_1,
                    percentage: this.model.stack && this.model.stackType === "percent"
                        ? Number(Number(percent).toFixed(2))
                        : undefined,
                });
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return {
            x: this.invert ? x : pos,
            y: this.invert ? pos : y,
            category: dValue,
            metaData: metaData,
            index: index,
        };
    };
    /**
     * 通过分类坐标名获取数据
     * @param category
     */
    Bar.prototype.getDataFromCategory = function (category) {
        var e_6, _a;
        var alias = this.ctx.getOption("scale." + this.valueKey + ".alias");
        var metaData = [];
        try {
            for (var _b = tslib_1.__values(this.model.getDataFromCategoryName(category, true)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = _c.value, serieName = _d.serieName, colorName = _d.colorName, value = _d.value, origin_2 = _d.origin, percent = _d.percent;
                metaData.push({
                    title: category,
                    label: alias || (serieName === "default" ? this.valueKey : serieName),
                    serieName: serieName,
                    valueText: typeof value === "number" ? d3_1.format(",")(value) : "-",
                    color: this.colorScale(colorName),
                    value: value,
                    row: origin_2,
                    percentage: this.model.stack && this.model.stackType === "percent"
                        ? Number(Number(percent).toFixed(2))
                        : undefined,
                });
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return metaData;
    };
    /**
     * 通过值获取坐标
     * @param category 分类值
     * @param value 数据值
     */
    Bar.prototype.getPosition = function (category, value) {
        var categoryScale = this.categoryScale[0];
        return [categoryScale(category), this.valueScale(value)];
    };
    /**
     * 绘制标记线和标记点
     * @param eventData 当前数据点信息
     * @since 2.0
     * @todo 修复最后一个点不显示的问题
     */
    Bar.prototype.drawHover = function (eventData) {
        var _this = this;
        var left = this.ctx.theme.padding.left;
        var _a = tslib_1.__read(this.categoryScale, 1), axisScale = _a[0];
        var x = eventData.x, y = eventData.y;
        var offsetX = parseInt(this.ctx.plotBackgound.attr("x"), 10);
        var offsetY = parseInt(this.ctx.plotBackgound.attr("y"), 10);
        var height = parseInt(this.ctx.plotBackgound.attr("height"), 10);
        var width = parseInt(this.ctx.plotBackgound.attr("width"), 10);
        var bandwidth = axisScale.bandwidth();
        var padding = axisScale.padding() * bandwidth;
        var strokeWidth = bandwidth < padding ? bandwidth : bandwidth + padding;
        // 绘制标记线
        this.crosshair
            .attr("stroke-width", strokeWidth)
            .attr("d", function () {
            if (_this.invert) {
                return "M" + (offsetX + left) + "," + y + "L" + (width + offsetX) + "," + y;
            }
            return "M" + x + "," + offsetY + "L" + x + "," + (height + offsetY);
        })
            .attr("visibility", "visible");
    };
    /**
     * 隐藏标记线和标记点
     * @since 2.0
     */
    Bar.prototype.removeHover = function () {
        this.crosshair.attr("visibility", "hidden");
        this.seriesGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-markers circle")
            .attr("opacity", "0");
        this.helpers.tooltip.hide();
    };
    /**
     * 监听图例事件
     * @param legendData LegendData
     */
    Bar.prototype.onLegendItemHover = function (_a) {
        var index = _a.index;
        this.ctx.root
            .selectAll("." + this.ctx.classPrefix + "-chart-series")
            .attr("opacity", 0.1);
        this.ctx.root
            .selectAll("." + this.ctx.classPrefix + "-chart-data-labels")
            .attr("opacity", 0.1);
        this.ctx.root
            .selectAll("." + this.ctx.classPrefix + "-chart-series-" + index)
            .attr("opacity", 1);
    };
    /**
     * 监听图例事件
     * @param legendData LegendData
     */
    Bar.prototype.onLegendItemLeft = function () {
        this.ctx.root
            .selectAll("." + this.ctx.classPrefix + "-chart-series")
            .attr("opacity", 1);
        this.ctx.root
            .selectAll("." + this.ctx.classPrefix + "-chart-data-labels")
            .attr("opacity", 1);
    };
    /**
     * 图例点击事件
     * @param legendData 被点击的图例信息
     * @param disabled 改图例元素是否是禁用状态
     */
    Bar.prototype.onLegendClick = function (legendData, disabled) {
        var key = legendData.key;
        if (disabled) {
            this.disabledKeys.push(key);
        }
        else {
            this.disabledKeys = this.disabledKeys.filter(function (d) { return d !== key; });
        }
        this.model.filterColumns(this.disabledKeys);
        this.draw(false);
    };
    Bar.prototype.onClick = function (x, y) {
        var mappedData = this.getData(x, y);
        // 兼容以前的，想要以后去掉
        if (mappedData) {
            this.ctx.emit("click", mappedData);
        }
    };
    Bar.prototype.onZoom = function (range) {
        this.model.range(range);
        this.draw(false);
    };
    Bar.prototype.onZoomReset = function () {
        this.draw();
    };
    return Bar;
}(shape_1.Shape));
exports.Bar = Bar;
//# sourceMappingURL=bar.js.map